import { IHighwayInfoSchema } from '../../../../../repositories/monolith-python/entities/offer/HighwayInfoSchema';
import { TOfferHighways } from '../../../../reducers';

export const mapHighways = (highways: TOfferHighways | null): Array<IHighwayInfoSchema> | null => {
  if (!Array.isArray(highways)) {
    return null;
  }

  // Отфильтровываем незаполненные шоссе
  return highways.filter(({ id, name, distance }) => !!id && !!name && typeof distance === 'number');
};
